import { redirect } from 'react-router'
import { publicAction } from '@/data/loaders'

export function loadAssessment({ request, params }) {
  return new Promise(function(resolve, reject) {
    if (params.assessment_id == "new") {
      return resolve({});
    }

    publicAction("getAssessment", {
      id: params.assessment_id,
      course_id: params.course_id
    }).then(function({ data }) {
      if (data.value) {
        resolve({data: data});
      } else {
        reject({text: "Assessment not found", path: `/courses/${params.course_id}`, status: 404 });
      }
    }).catch(reject);
  })
}

export function loadAssessments({ request, params }) {
  return publicAction("getCourseAssessments", { id: params.course_id })
}

export function assessmentSubmitCreate({ request, params }) {
  return new Promise(function(resolve, reject) {
    request.json().then(function({ data, rubrics }) {

      publicAction("createAssessment", {
        data,
        rubrics,
        course_id: params.course_id,
        scenario_id: params.scenario_id
      }).then(function({ data }) {
        resolve(redirect("/courses/"+params.course_id))
      }).catch(function() {
        resolve({success: false, date: Date.now()});
      });

    })
  })
}

export function assessmentSubmitUpdate({ request, params }) {
  return new Promise(function(resolve, reject) {
    request.json().then(function({ data, rubrics }) {
      
      publicAction("updateAssessment", {
        data,
        rubrics,
        course_id: params.course_id,
        id: params.assessment_id
      }).then(function({ data }) {
        resolve(redirect("/courses/"+params.course_id))
      }).catch(function() {
        resolve({success: false, date: Date.now()});
      });

    })
  })
}

export function deleteAssessment({ course_id, id }) {
  return publicAction("deleteAssessment", { course_id, id })
}